// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1bEgr","row":"styles_row__3ZdzK"};